// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-legal-document-js": () => import("/Users/segevhaviv/Desktop/Projects/legal/src/templates/legal-document.js" /* webpackChunkName: "component---src-templates-legal-document-js" */),
  "component---src-pages-404-js": () => import("/Users/segevhaviv/Desktop/Projects/legal/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-app-index-js": () => import("/Users/segevhaviv/Desktop/Projects/legal/src/pages/app/index.js" /* webpackChunkName: "component---src-pages-app-index-js" */),
  "component---src-pages-index-js": () => import("/Users/segevhaviv/Desktop/Projects/legal/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

